import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { StyledFormItem } from '../../components/styledComponents';
import { useChangeMyPasswordMutation } from '../../redux/api/userApis/usersApi';
import { ChangePassword } from '../../models/changePswd';
import { useDispatch, useSelector } from 'react-redux';
import { AuthSliceMethods, getAuthState } from '../../redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../redux/root/root.store';
import { Paths } from '../../paths';
import InputPassword from '../../components/inputs/inputPassword';
import { useTranslation } from 'react-i18next';
import { getCookie } from "typescript-cookie";
const StyledForm = styled(Form)`
  width: 400px;
  margin: auto;  
  background: #f1f7fe;
  padding: 2em;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0 0 2em #e6e9f9;
`;
const LoginPage = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  aligne-items: center;
  justify-content : center;
  background: #dde5f4;
`;
const InputLoginPas = styled(Input.Password)`
  background: #ffffff;
  box-shadow: 0px 6px 46px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  padding: 10px 12px;
`;
const ButtonLogin = styled(Button)`
  padding: 26px 24px;
  background: #3e4684;
  color: white;
  border: none;
  border-radius: 3px;
  font-weight: 600;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const ChangePasswordPage = () => {
  const [form] = useForm();
  const { pin, roles } = useSelector(getAuthState);
  const [changePassword] = useChangeMyPasswordMutation();
  const [loading, setLoading] = useState<boolean>(false);
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const [ currPassLen, setCurrPassLen ] = useState<number | null>(null);


  useEffect(() => {
    if (roles && roles.length > 0) {
      const maxPasswordLength = Math.max(
      ...roles
        .map((role) => role.passwordLength ?? 0)
      );
      setCurrPassLen(maxPasswordLength > 0 ? maxPasswordLength : null);
    } else {
      setCurrPassLen(null);
    }
    }, [  ]);
  async function onChangePassword(newPassword: ChangePassword): Promise<boolean> {
    try {
      let status: boolean = false;
      await changePassword(newPassword).then(async (response: any) => {
             if (response.error) {
                           const isKyrgyz = getCookie('i18next') === 'ky';
                           const lang = isKyrgyz ? 'kg' : 'ru';
                           const res = response.error.data?.res;
                           const errorMessages = Array.isArray(res)
                               ? res.map((error: any) => error[lang] || error.ru).join('\n')
                               : response.error.data?.msg || t('unknownError'); 
                           throw new Error(errorMessages);
                       }
        if (response.data.success) {
          status = true;
          const response: any = await dispatch(AuthSliceMethods.getUserInfo());
          if (response.payload) {
            if (!response.payload.changePasswordNextLogon) {
              navigate(Paths.home, { replace: false });
            } else {
              navigate(Paths.changePassword, { replace: false });
            }
          }
        }
      }).catch((error: any) => {
        modal.error({ title: 'Ошибка', content: String(error.message) });
      });
      return status;
    } catch (error: any) {
      modal.error({ title: 'Ошибка', content: String(error.message) });
      return false;
    }
  }

  const getEntityFromFields = (): ChangePassword => {
    let password = new ChangePassword();
    password.pin = pin;
    password.oldPassword = form.getFieldValue('oldPassword');
    password.password = form.getFieldValue('newPasswordConfirm');
    return password;
  }

  const handleChange = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      const password = getEntityFromFields();
      const result = await onChangePassword(password);
      if (result) {
        navigate(Paths.home);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <LoginPage >
      <StyledForm
        form={form}
        className="form_login"
        name="basic"
        initialValues={{ remember: true }}
        autoComplete="off"
        layout="vertical"
      >
        <StyledFormItem
          label="Старый пароль"
          name="oldPassword"
          rules={[{ required: true, message: "Заполнить" }]}
        >
          <InputLoginPas className="login_input" />
        </StyledFormItem>

        <StyledFormItem
          label="Новый пароль"
          name='newPassword'
          rules={[
            { required: true, message: t("msg.fill_in_the_field") },
            { pattern: new RegExp(/^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&? ".]).*$/, 'g'), message: t('auth.passwordValidationErrorMessage') }
          ]}
          hasFeedback
        >

          <InputPassword passwordLength={currPassLen} size="large" />
        </StyledFormItem>
        <StyledFormItem
          label="Подтвердите пароль"
          name="newPasswordConfirm"
          rules={[
            { required: true, message: 'Заполнить' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Пароли не совпадает"));
              }
            })
          ]}
        >
          <InputLoginPas />
        </StyledFormItem>
        <ButtonLogin loading={loading} type="primary" htmlType="submit" onClick={handleChange}>Поменять</ButtonLogin>
      </StyledForm>
      {contextHolder}
    </LoginPage>
  )
}
